import type { FC, ReactNode } from 'react'

import { cn } from '@/lib/utils'
import Tag from '@/components/elements/tag'

interface TechnologyListProps {
    items: Array<string>
    variant?: 'inline' | 'tags'
    className?: string
    label?: string
}

/** Technologies as a slash-separated mono line, or as bordered tags. */
const TechnologyList: FC<TechnologyListProps> = ({ items, variant = 'inline', className, label = 'Technologies' }): ReactNode => {
    if (items.length === 0) return null

    if (variant === 'tags') {
        return (
            <ul aria-label={label} className={cn('flex flex-wrap gap-1.5', className)}>
                {items.map((item) => (
                    <li key={item}>
                        <Tag>{item}</Tag>
                    </li>
                ))}
            </ul>
        )
    }

    return (
        <ul aria-label={label} className={cn('flex flex-wrap gap-x-2 gap-y-1 font-mono text-caption text-muted-foreground', className)}>
            {items.map((item, index) => (
                <li key={item} className='flex items-center gap-2'>
                    {index > 0 && <span aria-hidden='true' className='text-border-strong'>/</span>}
                    <span>{item}</span>
                </li>
            ))}
        </ul>
    )
}

export default TechnologyList
